/* eslint-disable max-lines */
/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
import { a11yProps } from '../../deals';
import AddCompanyModal from '../../../components/client_dashboard/modal/add_company';
import AddProjectModal from '../../../components/client_dashboard/modal/add_project';
import CardWrapper from '../../../components/wrapper/card';
import CustomInput from '../../../components/reusable/input';
import { fetchAgencysClientAnalyticsThunk } from '../../../redux/thunks/chart';
import { fetchAllUrgentTasksThunk } from '../../../redux/thunks/task';
import { fetchTeamThunk } from '../../../redux/thunks/team';
import { formatTimeUptoNow } from '../../../helper';
import { useNavigate } from 'react-router';
import {
    Add,
    AddOutlined,
    Business,
    GroupAdd as GroupAddIcon,
    List,
    Search,
    SwapVertOutlined,
    VisibilityOutlined
} from '@mui/icons-material';
import { addRemoveClientAssigneeThunk, fetchAllClientsThunk } from '../../../redux/thunks/client';
import { AddRemoveClientParams, ClientAssigneeObject, ClientObject } from '../../../params/redux/client';
import { AppDispatch, RootState } from '../../../redux/store';
import {
    Avatar,
    AvatarGroup,
    Box,
    Button,
    IconButton,
    InputAdornment,
    Popover,
    Tab,
    Tabs,
    Tooltip,
    Typography
} from '@mui/material';
import { brand, gray, green, orange, red } from '../../../theme/themePrimitives';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface DealsRow {
    id: number;
    company: string;
    leader: string;
    team: ClientAssigneeObject[];
}

const ClientManagementDashboard = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [value, setValue] = useState(0);
    const [searched, setSearched] = useState('');
    const [sort, setSort] = useState<boolean>(false);
    const [addCompany, setAddCompany] = useState<boolean>(false);
    const [addProject, setAddProject] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedClientId, setSelectedClientId] = useState<number | null>(null);
    const { currentUser } = useSelector((state: RootState) => state.app);
    const { clients, loaders: clientLoaders } = useSelector((state: RootState) => state.client);
    const { client_agency_dashboard } = useSelector((state: RootState) => state.chart);
    const { dueTasks } = useSelector((state: RootState) => state.task);
    const { teams } = useSelector((state: RootState) => state.team);

    useEffect(() => {
        const fetchAllClients = async () => {
            try {
                await Promise.all([
                    dispatch(fetchAgencysClientAnalyticsThunk()).unwrap(),
                    dispatch(fetchAllClientsThunk()).unwrap(),
                    dispatch(fetchAllUrgentTasksThunk()).unwrap(),
                    dispatch(fetchTeamThunk()).unwrap()
                ]);
                // await dispatch(fetchAgencysClientAnalyticsThunk()).unwrap();
                // await dispatch(fetchAgencysClientAnalyticsThunk()).unwrap();
                // await dispatch(fetchAllClientsThunk()).unwrap();
                // await dispatch(fetchAllUrgentTasksThunk()).unwrap();
                // await dispatch(fetchTeamThunk()).unwrap();
            } catch (e) {
                // Catch errors
            }
        };
        fetchAllClients();
    }, []);

    const filteredClients = clients.filter((client: ClientObject) => (
        client.company_name?.toLowerCase().includes(searched.toLowerCase()) ||
        client.contact_number?.toLowerCase().includes(searched.toLowerCase())
    ));

    const sortedClients = sort
        ? [...filteredClients].sort((a, b) => a.company_name.localeCompare(b.company_name))
        : filteredClients;

    const companyClients = sortedClients.filter((client: ClientObject) => client.company_type === 'company');
    const projectClients = sortedClients.filter((client: ClientObject) => client.company_type !== 'company');
    const displayedClients = value === 0 ? companyClients : projectClients;

    const rows: DealsRow[] = displayedClients.map((client: ClientObject) => ({
        id: client.id,
        company: client.company_name || '',
        leader: client.contact_number || '',
        team: client.assignees
    })) || [];

    const handleViewClient = (id: number) => navigate(`/app/client/${id}/dashboard`);

    const handleOpenPopover = (event: React.MouseEvent<HTMLElement>, clientId: number) => {
        setAnchorEl(event.currentTarget);
        setSelectedClientId(clientId);
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
        setSelectedClientId(null);
    };

    const callApi = async (values: AddRemoveClientParams) => {
        try {
            await dispatch(addRemoveClientAssigneeThunk(values)).unwrap();
        } catch (e) {
            //
        }
    };

    // Handle adding a new assignee
    const handleAddAssignee = (newAssigneeId: number) => {
        const exist = (rows as DealsRow[]).some((r) => (r.id === selectedClientId && r.team.some((t) => t.assignee_id === newAssigneeId)));
        if (exist) {
            const dataForApi: AddRemoveClientParams = {
                client_id: selectedClientId as number,
                assignees: newAssigneeId,
                is_add: 0
            };
            callApi(dataForApi);
        } else {
            const dataForApi: AddRemoveClientParams = {
                client_id: selectedClientId as number,
                assignees: newAssigneeId,
                is_add: 1
            };
            callApi(dataForApi);
            handleClosePopover();
        }
    };

    const columns: GridColDef<DealsRow>[] = [
        {
            field: 'company',
            headerName: value === 1 ? 'PROJECT' : 'COMPANY',
            flex: 1,
            renderCell: (params: GridRenderCellParams<DealsRow, string>) => <Box display="flex" alignItems="center" gap="5px" my="15px">
                <Business />
                <Typography variant="body2">{params.value}</Typography>
            </Box>
        },
        { field: 'leader', headerName: 'Phone Number', flex: 1 },
        {
            field: 'team',
            headerName: 'TEAM',
            flex: 1,
            renderCell: (params: GridRenderCellParams<DealsRow, ClientAssigneeObject[]>) => (
                <Box display="flex" alignItems="center" gap={1} my={1}>
                    {/* Profile Badges */}
                    {params.value && params.value?.length > 0 && (
                        <AvatarGroup max={4}>
                            {params.value.map((assignee) => (
                                <Tooltip key={assignee.user?.id || 0} title={`${assignee?.user?.first_name || ''} ${assignee?.user?.last_name || ''}`}>
                                    <Avatar src={assignee?.user?.first_name || ''} sx={{ width: 30, height: 30, bgcolor: gray[300], color: 'white' }}>
                                        {/* {assignee.user.first_name.charAt(0)}
                                            {assignee.user.last_name.charAt(0)} */}
                                    </Avatar>
                                </Tooltip>
                            ))}
                        </AvatarGroup>
                    )}
                    {/* Add Assignee Button */}
                    {currentUser?.role !== 'companyManager' && <Box bgcolor={brand[300]} borderRadius="20px" height={30} width={30} display="flex" justifyContent="center" alignItems="center" color="white" onClick={(e) => handleOpenPopover(e, params.row.id)}>
                        <Add />
                    </Box>}
                </Box>
            )
        },
        {
            field: 'id',
            headerName: 'ACTIONS',
            flex: 1,
            renderCell: (params: GridRenderCellParams<DealsRow, number>) => <Box display="flex" alignItems="center" my="5px">
                <IconButton onClick={() => handleViewClient(params.value as number)}>
                    <VisibilityOutlined fontSize="small" color="info" />
                </IconButton>
                {/* <IconButton>
                    <ArchiveOutlined fontSize="small" color="info" />
                </IconButton>
                <IconButton onClick={() => null}>
                    <PushPinOutlined fontSize="small" color="info" />
                </IconButton> */}
            </Box>
        }
    ];
    const statistics = [
        {
            name: 'Active Companies',
            value: client_agency_dashboard.active_companies,
            icon: <GroupAddIcon fontSize="small" color="success" />,
            color: green[50]
        },
        {
            name: 'Revenue per company',
            value: `$ ${client_agency_dashboard.revenue_per_company}`,
            icon: <GroupAddIcon fontSize="small" color="primary" />,
            color: brand[50]
        },
        {
            name: 'Company Lifecycle',
            value: `${client_agency_dashboard.company_lifecycle} Hours`,
            icon: <GroupAddIcon fontSize="small" color="warning" />,
            color: orange[50]
        },
        {
            name: 'Retention Rate',
            value: `${client_agency_dashboard.retention_rate.toFixed(2)} %`,
            icon: <GroupAddIcon fontSize="small" color="error" />,
            color: red[50]
        }
    ];

    return (
        <Box padding={2} minHeight="80vh" overflow="auto">
            <CardWrapper>
                {/* Welcome Header */}
                <Typography variant="h5" gutterBottom>
                    Welcome <span style={{ color: brand[300] }}>{currentUser?.name || `${currentUser?.first_name} ${currentUser?.last_name}`}</span>
                </Typography>

                {/* Statistics Section */}
                <CardWrapper>
                    <Typography variant="h6" color="textSecondary" mb={2}>Statistics</Typography>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        {
                            statistics.map((stat, index) => (
                                <Box display="flex" alignItems="center" gap="10px" key={index}>
                                    <Box display="flex" alignItems="center" justifyContent="center" bgcolor={stat.color} p={1} borderRadius="10px">
                                        {stat.icon}
                                    </Box>
                                    <Box>
                                        <Typography variant="body2" color="textSecondary">{stat.name}</Typography>
                                        <Typography variant="h6">{stat.value}</Typography>
                                    </Box>
                                </Box>))
                        }
                    </Box>
                </CardWrapper>

                <Box display="flex" gap="10px" mt={2}>
                    <CardWrapper>
                        <Tabs
                            value={value}
                            onChange={(e, newValue) => setValue(newValue)}
                            aria-label="comapnies details tabs"
                        >
                            <Tab label="Companies" {...a11yProps(0)} />
                            <Tab label="Projects" {...a11yProps(1)} />
                        </Tabs>
                        <Box display="flex" gap="10px" my={2}>
                            <CustomInput
                                placeholder={value === 1 ? 'Search Project' : 'Search Company'}
                                fullWidth
                                value={searched}
                                slotProps={{
                                    input: {
                                        startAdornment: <InputAdornment position="start">
                                            <Search />
                                        </InputAdornment>
                                    }
                                }}
                                onChange={(event) => setSearched(event.target.value)}
                            />
                            <Box display="flex" gap="10px">
                                {currentUser?.role !== 'companyManager' && <Button fullWidth variant="contained" sx={{ minWidth: '200px' }} onClick={() => (value === 1 ? setAddProject(true) : setAddCompany(true))}>
                                    <AddOutlined /> Add a {value === 1 ? 'project' : 'company'}
                                </Button>}
                                <Button variant="outlined" color={sort ? 'primary' : 'secondary'} fullWidth onClick={() => setSort(!sort)} startIcon={<SwapVertOutlined />}>
                                    Sort
                                </Button>
                                {/* <Button fullWidth variant="outlined" color="secondary">
                                    Archived
                                </Button> */}
                            </Box>
                        </Box>
                        <Box height="50vh" width="100%">
                            <DataGrid
                                rows={rows as DealsRow[]}
                                loading={clientLoaders.isLoading}
                                columns={columns}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 8
                                        }
                                    }
                                }}
                                sx={{
                                    '& .MuiDataGrid-row--borderBottom': {
                                        backgroundColor: `${brand[50]} !important`
                                    },
                                    '& .MuiDataGrid-columnHeaderTitle': {
                                        fontWeight: 'bold'
                                    }
                                }}
                                pageSizeOptions={[8]}
                            />
                        </Box>
                        <Popover
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={handleClosePopover}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        >
                            <Box p={2} width="250px">
                                {teams.filter((item) => item.role !== 'organizationOwner' && item.id !== currentUser?.id).map((member) => (
                                    <Box
                                        key={member.id}
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        onClick={() => handleAddAssignee(member.id)}
                                    >
                                        <Typography variant="subtitle2" color="textDisabled" fontWeight="bold" >{member.first_name} {member.last_name}</Typography>
                                        <Button
                                            variant="text"
                                            color={(rows as DealsRow[]).some((r) => (r.id === selectedClientId && r.team.some((t) => t.assignee_id === member.id))) ? 'error' : 'primary'}>
                                            {rows.some((r) => (r.id === selectedClientId && r.team.some((t) => t.assignee_id === member.id))) ? 'Remove' : 'Add'}
                                        </Button>
                                    </Box>
                                ))}
                            </Box>
                        </Popover>
                    </CardWrapper>

                    <CardWrapper>
                        <Typography variant="h6" color="textSecondary" mb={2} >Urgent due tasks</Typography>
                        {dueTasks.length === 0
                            ? <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="50vh">
                                <Typography variant="body2" color="textSecondary" mb={2}>No task is added</Typography>
                                <List fontSize="large" color="info" />
                            </Box>
                            : <Box maxHeight="60vh" overflow="auto">
                                {
                                    dueTasks.map((task, index) => (
                                        <Box
                                            key={index}
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="start"
                                            mb={2}
                                        >
                                            <Box display="flex" alignItems="center" gap={2}>
                                                <Box
                                                    width={10}
                                                    height={10}
                                                    borderRadius="50%"
                                                    mt={0.5}
                                                    bgcolor={task.label_color_tag === 'danger' ? red[300] : task.label_color_tag === 'success' ? green[300] : task.label_color_tag === 'warning' ? orange[300] : brand[300]}
                                                />
                                                <Box>
                                                    <Typography variant="subtitle1" fontWeight="bold">{task.title}</Typography>
                                                    <Typography variant="body2">{task.description}</Typography>
                                                </Box>
                                            </Box>
                                            <Typography variant="body2" color="textSecondary" minWidth="90px" textAlign="right">{formatTimeUptoNow(task.due_date)}</Typography>
                                        </Box>
                                    ))
                                }
                                {
                                    dueTasks.map((task, index) => (
                                        <Box
                                            key={index}
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="start"
                                            mb={2}
                                        >
                                            <Box display="flex" alignItems="center" gap={2}>
                                                <Box
                                                    width={10}
                                                    height={10}
                                                    borderRadius="50%"
                                                    mt={0.5}
                                                    bgcolor={task.label_color_tag === 'danger' ? red[300] : task.label_color_tag === 'success' ? green[300] : task.label_color_tag === 'warning' ? orange[300] : brand[300]}
                                                />
                                                <Box>
                                                    <Typography variant="subtitle1" fontWeight="bold">{task.title}</Typography>
                                                    <Typography variant="body2">{task.description}</Typography>
                                                </Box>
                                            </Box>
                                            <Typography variant="body2" color="textSecondary" minWidth="90px" textAlign="right">{formatTimeUptoNow(task.due_date)}</Typography>
                                        </Box>
                                    ))
                                }
                            </Box>
                        }
                    </CardWrapper>
                </Box>

            </CardWrapper>
            <AddCompanyModal open={addCompany} onClose={() => setAddCompany(false)} />
            <AddProjectModal open={addProject} onClose={() => setAddProject(false)} />
        </Box>
    );
};

export default ClientManagementDashboard;
